import React, { useEffect } from 'react'

export const useOnClickOutside = ({
  elementRef,
  onClick,
}: {
  elementRef: React.RefObject<HTMLElement | null>
  onClick: (event: MouseEvent) => void
}): void => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (
        elementRef.current &&
        !elementRef.current.contains(event.target as HTMLElement)
      ) {
        onClick(event)
      }
    }

    document.addEventListener('click', handleClickOutside, false)
    return () => {
      document.removeEventListener('click', handleClickOutside, false)
    }
  }, [elementRef, onClick])
}
